import httpClient from "./httpClient";
const END_POINT = "/api/reports_types";

const getAllTemplates = (item) => httpClient.get(END_POINT+'_list/' + item);
const getAllTemplatesPaginated = (page, perPage) => httpClient.get(`${END_POINT}?page=${page}&per_page=${perPage}`);
const getTemplate = (id) => httpClient.get(END_POINT + '/' + id);
const addTemplate = (rapportType) => httpClient.post(END_POINT, rapportType);
const updateTemplate = (rapportType) => httpClient.put(END_POINT, rapportType);
const deleteTemplate = (id) => httpClient.delete(END_POINT + '/' + id)
const exportTypeReport = id =>
  httpClient.get(END_POINT + "/export/" + id,  {responseType: 'blob'});
export {
  getTemplate,
  getAllTemplates,
  getAllTemplatesPaginated,
  addTemplate,
  updateTemplate,
  deleteTemplate,
  exportTypeReport
}